import { Box, Collapse, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { MediumCustomIcon } from "../../layer00";
import { RIGHT_PANEL_GUTTER } from "../RightPanelLayout/RightPanelLayout";

type SettingsSectionProps = {
  label: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export const SettingsSection = (props: SettingsSectionProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const getSectionBackground = () => {
    if (!props.isExpanded) return "transparent";
    return isDark
      ? theme.palette.background.default
      : "var(--team-app-stripe-mid)";
  };

  const getHeaderBackground = () => {
    if (isDark) return theme.palette.background.paper;
    return props.isExpanded ? "rgba(255, 255, 255, 0.30)" : "#FFFFFF";
  };

  return (
    <Box
      borderTop={`1px solid ${isDark ? theme.palette.divider : "#ECEEF9"}`}
      bgcolor={getSectionBackground()}
    >
      <Box
        component="button"
        type="button"
        onClick={props.onToggle}
        aria-expanded={props.isExpanded}
        display="flex"
        flexDirection="row"
        alignItems="center"
        columnGap=".25rem"
        width="100%"
        paddingY=".75rem"
        paddingX={RIGHT_PANEL_GUTTER}
        border="none"
        bgcolor={getHeaderBackground()}
        sx={{
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <Typography
          variant="navBarGroupTitle"
          flex="1 1 0"
          minWidth={0}
          noWrap
          color={isDark ? theme.palette.text.secondary : "#4C6283"}
        >
          {props.label}
        </Typography>
        <MediumCustomIcon
          icon={props.isExpanded ? "CHEVRONUP" : "CHEVRONDOWN"}
          stroke="#7F8FA6"
          width={12}
          height={12}
        />
      </Box>
      <Collapse in={props.isExpanded}>
        <Box paddingTop=".5rem" paddingX={RIGHT_PANEL_GUTTER} paddingBottom="1rem">
          {props.children}
        </Box>
      </Collapse>
    </Box>
  );
};
